// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer__DedWhyLP{display:flex;justify-content:space-between}.top-spacer__m_IixIhu{margin-top:18px}.input__bM4pRSHj{padding:20px 0}.divider__izTf3Q4J{border-bottom:1px solid var(--component-outline-color);margin:32px 0 16px}.empty-state__x7ZsJr6L{align-items:center;display:flex;height:150px;justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": "footer__DedWhyLP",
	"topSpacer": "top-spacer__m_IixIhu",
	"input": "input__bM4pRSHj",
	"divider": "divider__izTf3Q4J",
	"emptyState": "empty-state__x7ZsJr6L"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
